import { AxiosRequestConfig } from 'axios'

import apiPath from '../constant/api-path'
import axios from '../utils/axios'

type NewAPIConfig = AxiosRequestConfig & { useNewAPI: boolean }

export const submitLogin = (
  body: unknown,
  headers: Record<string, string | undefined>
) => {
  const config: NewAPIConfig = { useNewAPI: true, headers }
  return axios.post(apiPath.LOGIN_NEW, body, config)
}

export const otpRequest = (
  body: unknown,
  headers: Record<string, string | undefined>
) => {
  const config: NewAPIConfig = { useNewAPI: true, headers }
  return axios.post(apiPath.OTP_REQUEST, body, config)
}

export const otpVerify = (
  body: unknown,
  headers: Record<string, string | undefined>
) => {
  const config: NewAPIConfig = { useNewAPI: true, headers }
  return axios.post(apiPath.OTP_VERIFY, body, config)
}

export const submitSetPassword = (body: unknown) =>
  axios.put(apiPath.SET_PASSWORD, body)

export const forgotPasswordService = (body: unknown) =>
  axios.put(apiPath.FORGOT_PASSWORD, body)

export const resetPassword = (body: unknown) =>
  axios.put(apiPath.RESET_PASSWORD, body)

export const checkSetPasswordToken = (token: string) =>
  axios.get(apiPath.CHECK_SET_PASSWORD_TOKEN(token))

export const logout = () => {
  const config: NewAPIConfig = { useNewAPI: true }
  return axios.get(apiPath.LOGOUT, config)
}

export const getUserInstitutions = () => {
  const config: NewAPIConfig = { useNewAPI: true }
  return axios.get(apiPath.USER_INSTITUTIONS, config)
}

export const generateInstitutionToken = () => {
  const config: NewAPIConfig = { useNewAPI: true }
  return axios.get(apiPath.USER_INSTITUTIONS_GENERATE_TOKEN, config)
}
